export const onlyDigits = (value) => String(value).replace(/\D/g, '');
